import { render, staticRenderFns } from "./SNotification.vue?vue&type=template&id=2cb597ea&scoped=true"
import script from "./sNotification.ts?vue&type=script&lang=ts&external"
export * from "./sNotification.ts?vue&type=script&lang=ts&external"
import style0 from "./SNotification.vue?vue&type=style&index=0&id=2cb597ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb597ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb597ea')) {
      api.createRecord('2cb597ea', component.options)
    } else {
      api.reload('2cb597ea', component.options)
    }
    module.hot.accept("./SNotification.vue?vue&type=template&id=2cb597ea&scoped=true", function () {
      api.rerender('2cb597ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-notification/SNotification.vue"
export default component.exports